import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { JobState } from '../../store/state/job-details.state';
import { jobDetailsLoaded } from '../../store/selectors/job-details.selectors';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { JobDetails } from '../../../models/job-details.model';

@UntilDestroy()
@Component({
  selector: 'nova-locums-recruiter-general',
  templateUrl: './locums-recruiter-general.component.html',
  styleUrls: ['./locums-recruiter-general.component.scss']
})
export class LocumsRecruiterGeneralComponent implements OnInit {

  
  @Input() id: number;

  job: JobDetails;

  constructor(private readonly _store: Store<JobState>) { }

  ngOnInit(): void {
    this._store
    .select(jobDetailsLoaded)
    .pipe(untilDestroyed(this))
    .subscribe((e) => {
      if (e.success) {
        this.job = e.job;
      }
    });
  }
}
